export default "__VITE_ASSET__BARKG1Xu__"